<template>
  <v-dialog persistent v-model="value" max-width="500">
    <v-card>
      <v-card-title class="headline">
        {{$t('Pages.Users.equipment_list')}}
        <v-flex class="text-xs-right" v-if="items && items.length > 0">
          <v-tooltip top>
            <v-btn
              slot="activator"
              small
              fab
              dark
              color="indigo dark1"
              :loading="loading"
              @click="getActiveUserCheckoutForms(1)">
              <v-icon dark>mdi-download</v-icon>
            </v-btn>
            <span>{{$t('Core.Fields.download')}}</span>
          </v-tooltip>
        </v-flex>
      </v-card-title>

      <v-card-text>
        <v-layout column wrap>
          <v-flex xs12 md5>
            <ol v-if="items && items.length > 0">
              <li v-for="item in items" :key="item.product_id">
                <p><span class="font-weight-medium">{{$t('Pages.Products.model.name')}}:</span> {{ item.product }}</p>
                <p><span class="font-weight-medium">{{$t('Pages.Products.model.quantity')}}:</span> {{ item.quantity }}</p>
              </li>
            </ol>
            <p v-else class="font-weight-medium text-xs-center">{{$t('Pages.Users.empty_equipment_list')}}</p>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click="close">
            {{$t('Core.Fields.close')}}
          </v-btn>

          <v-btn dark color="success dark1" @click="confirmDialog = true" v-if="items && items.length > 0">
            {{$t('Pages.Users.return_all_equipment')}}
          </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="confirmDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('Pages.Delete.title')}}</v-card-title>

        <v-card-text>
          {{$t('Pages.Delete.subtitle')}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error darken-1"
            @click="confirmDialog = false"
          >
            {{$t('Common.no')}}
          </v-btn>

          <v-btn
            color="info darken-1"
            :loading="loading"
            @click="save"
          >
            {{$t('Common.yes')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  export default {
  components: {},
  props: ['value'],
  data: () => ({
    loading: false,
    items: null,
    confirmDialog: false,
  }),
  computed: {
      
  },
  created () {

  },
  methods: {
    close(){
      this.$emit('close');
      this.items = null;
      this.confirmDialog = false;
    },
    getActiveUserCheckoutForms(shouldExport = 0){
      this.loading = true;
      const data = {}
      data.export = shouldExport;

      if (shouldExport == 1){
        this.repositories.user.searchByUserByActiveUserCheckoutFormsAndExport(this.$route.params.id, data)
        .finally(() => {
          this.loading = false;
        });
      } else {
        this.repositories.user.searchByUserByActiveUserCheckoutForms(this.$route.params.id, data)
        .then(response => {
          this.items = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
      }
    },
    save() {
      this.loading = true;
      this.repositories.user.returnAllEquipment(this.$route.params.id)
        .then(response => {
          this.$toast.success(response.data.message);
          this.close();
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },
  watch: {
    value: function() {
      if (this.value) {
        this.getActiveUserCheckoutForms();
      }
    }
  }
}
</script>

<style lang="scss">

</style>